<script setup lang="ts">
  import { computed } from 'vue';
  import PrinterIcon from '@/shared/assets/icons/PrinterIcon.svg';
  import { ColoredButton, ModalDocumentInfo } from '@/shared/ui';
  import { useBranchLogo } from '@/entities/Branch';
  import type { TrainingMatrixPositionRow } from '@/entities/Training';
  import TrainingMatrixReportTable from './TrainingMatrixReportTable.vue';
  import {
    TRAINING_MATRIX_REPORT_CONTENT_ID,
    useTrainingMatrixReportPrint,
  } from '../model/useTrainingMatrixReportPrint';

  const props = defineProps<{
    positions: TrainingMatrixPositionRow[];
    revisionNumber: number | null;
  }>();

  const documentInfo = computed(() => ({
    code: 'DA18.7',
    revision: `REV.${String(props.revisionNumber ?? 0).padStart(2, '0')}`,
  }));

  const { printTrainingMatrixReport } = useTrainingMatrixReportPrint();
  const { currentLogoUrl, handleLogoError } = useBranchLogo();
</script>

<template>
  <section
    class="flex flex-col gap-6 text-gray-07"
    data-testid="training-matrix-report-view"
  >
    <div class="flex items-center justify-between">
      <h1 class="text-left text-xl/7.5 font-semibold">
        Gerar Matriz
      </h1>
      <ColoredButton
        text="Imprimir"
        :icon="PrinterIcon"
        icon-alt="Imprimir"
        data-testid="training-matrix-report-print-button"
        @click="printTrainingMatrixReport"
      />
    </div>

    <div
      :id="TRAINING_MATRIX_REPORT_CONTENT_ID"
      class="overflow-hidden rounded-2xl border border-gray-02 bg-white-01"
    >
      <div class="border-b border-gray-02 p-6">
        <ModalDocumentInfo
          :document-info="documentInfo"
          main-label="DADOS"
          title="MATRIZ DE TREINAMENTO"
          :logo-url="currentLogoUrl"
          @logo-error="handleLogoError"
        />
      </div>

      <TrainingMatrixReportTable :positions="positions" />
    </div>
  </section>
</template>
